<template>
  <div>
    <iframe frameborder="0" id="iframe" v-show="showLogin"></iframe>
    <div v-show="!showLogin">
      <div class="content" ref="content">
        <div class="banner" v-if="!isShowVideo" ref="banner" :style="{ backgroundImage: 'url(' + bannerImg + ')' }"></div>
        <!--直播图标-->
        <div ref="liveAnimation" class="liveAnimation" v-if="isLive === 1" @click="jumpLive">
          <img src="../assets/live.gif" />
        </div>
        <!--直播图标结束-->
        <!--主播放器-->
        <div class="mainVideo" v-show="isShowVideo" ref="mainVideo">
          <div class="videoBox">
            <img v-lazy="posterImg" v-show="playPic" />
            <div class="playBtn" v-show="playPic">
              <img v-lazy="playBtnPic" @click.stop="playMainV()" />
            </div>
            <div class="disableFullscreen" @click.stop="disableFullscreen()"></div>
            <video
              width="100%"
              height="100%"
              class="videoplay"
              ref="mainV"
              v-show="isShowMainVideo"
              controls
              controlslist="nodownload nofullscreen"
              webkit-playsinline="true"
              x5-playsinline="x5-playsinline"
              playsinline="true"
              x-webkit-airplay="true"
              preload="none">
              <source v-bind:src="videoUrl" />
            </video>
          </div>
        </div>
        <fee></fee>
        <ins-plan ref="plan"></ins-plan>
        <img src="../assets/czs.png" alt="" style="width: 100%; margin-top: 2.66vw" />
        <div class="intro" ref="intro">
          <div :class="{ selected: introIndex === 0 }" @click.stop="changeIntro(0, '投保流程')">投保流程</div>
          <div :class="{ selected: introIndex === 1 }" @click.stop="changeIntro(1, '理赔流程')">理赔流程</div>
          <div :class="{ selected: introIndex === 2 }" @click.stop="changeIntro(2, '条款须知')">条款须知</div>
          <!-- <div :class="{ selected: introIndex === 3 }" @click.stop="changeIntro(3, '常见问题')">常见问题</div> -->
        </div>
        <ins-process ref="process"></ins-process>
        <claims-intro ref="claims"></claims-intro>
        <clause ref="clause"></clause>
        <com-problem ref="problem"></com-problem>
        <div class="notice">
          <div class="check-btn" :class="{ selected: readNotice }" @click="toggleReadNotice"></div>
          <p>
            我已阅读并确认
            <span @click="openNotice(0, '投保须知')">《投保须知》</span>、 <span @click="openNotice(1, '保险条款')">《保险条款》</span>、
            <span @click="openNotice(3, '客户告知书')">《客户告知书》</span>
            <!-- 、<span @click="openNotice(4, '产品费率说明')">《产品费率说明》</span> -->
          </p>
        </div>
        <div class="tips">
          <p>声明：本产品由中国平安财产保险股份有限公司承保，由天津华盛保险经纪提供经纪服务，<span @click="showCompliance">点击查阅本产品在中国保险行业协会披露信息</span></p>
        </div>
        <img ref="compliance" src="../assets/compliance.png" preview="0" style="display: none" alt="" />
        <!--小窗播放器-->
        <div class="smallVideo" ref="smallVideo" v-show="offMin && isShowVideo">
          <div class="smallVideoBox">
            <img class="close" @click.stop="stopSmallVideo()" v-lazy="closeBtnPic" />
            <img class="enlarge" @click.stop="enlargeToMainVideo()" v-lazy="enlargeBtnPic" />
            <video width="100%" height="100%" ref="smallV" webkit-playsinline="true" x5-playsinline="x5-playsinline" playsinline="true" x-webkit-airplay="true" preload="auto" muted autoplay>
              <source v-bind:src="videoUrl" />
            </video>
          </div>
        </div>
        <!--小窗播放器-->
      </div>
      <router-view></router-view>
      <div class="submit">
        <div class="customer" @click="callphone">联系客服</div>
        <div class="price">{{ showMoney }}</div>
        <div class="submit-btn" @click="doInsure">去投保</div>
      </div>
      <img src="../assets/top.png" v-show="showBackToTop" @click="backToTop" class="top-img" alt="" />
      <legalHome v-if="showLegal" @closeLegal="closeLegal"></legalHome>
    </div>
    <div v-if="customerServiceVisibile">
      <div class="mask"></div>
      <iframe frameborder="0" class="iframeService" :src="serviceUrl"></iframe>
    </div>

    <!-- 挽留弹框 -->
    <retentionDialog :show="showRetentionDialog" @confirm="onRetentionConfirm" @cancel="onRetentionCancel" />
  </div>
</template>

<script>
import InsProcess from "./InsProcess";
import ClaimsIntro from "./ClaimsIntro";
import Clause from "./Clause";
// import ComProblem from "./ComProblem";
import InsPlan from "./InsPlan";
import Fee from "./Fee";
import { mapGetters } from "vuex";
import { myTrack } from "../common/track";
import { Inertia } from "../common/inertia";
import qs from "qs";
import { getUserInfo, getUrlParams, showMsg, isAndroid, setSessionObj, getSessionObj, isUniapp } from "../common/utils";
import legalHome from "../components/legalHome/legalHome";

const productDetail = "/hsbxjj-excellent-driving-insurance/product/productDetail";
const wxConfigUrl = "/hsbxjj-insurance-sales/share/config/get";
const getRankingDataUrl = "/hsbxjj-excellent-driving-insurance/championship/getRankingData";
const buildInvitation = "/hsbxjj-excellent-driving-insurance/invitation/buildInvitation";
export default {
  name: "Home",
  components: {
    ClaimsIntro,
    Clause,
    // ComProblem,
    InsPlan,
    Fee,
    InsProcess,
    legalHome,
    retentionDialog: () => import("@/components/retentionDialog.vue"),
  },
  data() {
    return {
      isUniapp: isUniapp(),
      customerServiceVisibile: false,
      serviceUrl: `${window.location.origin}/hsbxjj-standard-common-insurance-page/#/customerService`,
      bannerImg: "",
      introIndex: 0,
      showBackToTop: false,
      backtrackingCode: "",
      showLegal: true,
      readNotice: false,
      isLive: 0,
      versionControl: window.daka || navigator.userAgent.indexOf("daka") > -1 || getUrlParams().daka === "1",
      //播放器数据定义开始
      isShowVideo: false, //是否有视频功能
      mainV: "",
      smallV: "",
      isShowMainVideo: false, //是否显示主播放器，解决视频自动加载黑圈问题
      posterImg: "", //封面图
      videoUrl: "", //视频地址
      playPic: true, //主体视频封面是否显示
      offMin: false, //滚动事件是否达到展示小窗播放器
      isPlay: false, //主播放器是否在播放中
      isClose: false, //是否点击了小窗口的关闭按钮
      playBtnPic: require("../assets/playBtn.png"),
      closeBtnPic: require("../assets/close.png"),
      enlargeBtnPic: require("../assets/enlarge.png"),
      //播放器数据定义结束
      productShareTitle: "",
      productSharePlans: "",
      productShareImgUrl: "",
      showLogin: false, //是否显示登录
      productName: "",
      productBannerUrl: "",
      rankingList: [],
      // 挽留弹框相关数据
      showRetentionDialog: false,
      // 标识当前是否在子路由（进入子路由时设置为true，返回时清除）
      hasChildRoute: false,
    };
  },
  computed: {
    ...mapGetters("policy", ["showMoney"]),
  },
  methods: {
    /**
     * 绑定分享者与当前登录人关系
     */
    buildShareHandle() {
      try {
        if (getSessionObj("dakaUser").userId && getSessionObj("sharerUserId") && getSessionObj("sharerUserId") != "undefined") {
          this.$http.post(buildInvitation, { userId: getSessionObj("dakaUser").userId, invitationUserId: getSessionObj("sharerUserId") }).then((res) => {});
        }
      } catch (e) {}
    },
    doInsure() {
      try {
        myTrack("bxsc_go_to_the_product_page", {
          click_apply: "点击去投保",
        });
      } catch (error) {
        window.console.log(error);
      }
      let _self = this;
      if (!this.readNotice) {
        showMsg("请阅读条款");
        this.$refs.content.scrollTop = this.$refs.content.scrollHeight;
        return;
      }
      if (window.insurebacktrackingCode) {
        this.backtrackingCode = window.insurebacktrackingCode;
      }
      if (navigator.userAgent.indexOf("daka") > -1 || (getSessionObj("dakaUser") && getSessionObj("dakaUser").mobile)) {
        this.buildShareHandle();
        this.$router.push({
          path: "/clausePage",
          query: {
            backtrackingCode: this.backtrackingCode,
          },
        });
      } else {
        let mcc, env;
        if (window.location.href.indexOf("insapp.hsbxjj.com") > -1) {
          mcc = "20200520135233717082";
          env = "cwPro";
        } else {
          mcc = "20190606175732387233";
          env = "cwTest";
        }
        this.showLogin = true;
        window.postUserCenter.sendpost({
          name: "iframe", // iframe id
          router: "login", // 用户中心登录页面路由
          mcc: mcc, // 商户号
          env: env,
          callback: function (data) {
            // 用户中心回调
            window.console.log(data);
            if (data.action === "login") {
              // 登录成功回调
              // window.console.log(data.);
              let postData = { tiket: data.ticket };
              postData = qs.stringify(postData);
              _self.$http.post("/hsbxjj-insurance-sales/usercenter/getUserInfoByH5Tiket", postData).then((res) => {
                // 将用户信息缓存
                let info = {};
                info.mobile = res.data.data.regPhoneDecrypt; //手机号
                info.userId = res.data.data.userId; //用户id
                info.nickName = res.data.data.userNickName; //昵称
                info.avatar = res.data.data.headPic; //头像
                info.sex = res.data.data.userSex; //1 男 2 女
                setSessionObj("dakaUser", info);
                setTimeout(() => {
                  _self.buildShareHandle();
                  _self.$router.push({
                    path: "/clausePage",
                    query: {
                      backtrackingCode: _self.backtrackingCode,
                    },
                  });
                }, 10);
              });
            }
          },
        });
      }
    },
    changeIntro(index, tabName) {
      let space = this.$refs.intro.offsetHeight + parseInt(getComputedStyle(this.$refs.intro).marginBottom);
      if (index === 0) {
        this.$refs.content.scrollTop = this.$refs.process.$el.offsetTop - space;
      } else if (index === 1) {
        this.$refs.content.scrollTop = this.$refs.claims.$el.offsetTop - space;
      } else if (index === 2) {
        this.$refs.content.scrollTop = this.$refs.clause.$el.offsetTop - space;
      } else {
        this.$refs.content.scrollTop = this.$refs.problem.$el.offsetTop - space;
      }
      this.introIndex = index;
      try {
        myTrack("bxsc_go_to_the_product_page", {
          click_insurance_process: tabName,
        });
      } catch (error) {
        window.console.log(error);
      }
    },
    closeLegal() {
      this.showLegal = false;
    },
    backToTop() {
      this.$refs.content.scrollTop = 0;
    },
    showCompliance() {
      this.$refs.compliance.click();
    },
    openNotice(type,title) {
      try {
        myTrack("bxsc_go_to_the_product_page", {
          click_bottom_terms_notice: title,
        });
      } catch (error) {
        window.console.log(error);
      }
      if (type === 0) {
        this.$router.push({ path: "home/InsNotice" });
      } else if (type === 1) {
        this.$router.push({ path: "home/InsClause" });
      } else if (type === 3) {
        this.$router.push({ path: "home/CustomerPage" });
      } else if (type === 4) {
        this.$router.push({ path: "home/rateDescription" });
      }
    },
    //跳转直播
    jumpLive: function () {
      const userIdUrl = "/hsbxjj-standard-common-insurance/standardinsurance/live/getLiveConfig";
      let data = {};
      data.userId = getUserInfo().userId;
      data.productCode = getUrlParams().productCode || "";
      this.$http
        .post(userIdUrl, data)
        .then((res) => {
          window.location.href = res.data.data.liveBasicInfo.pushUrl;
        })
        .catch(() => {});
    },
    //视频操作开始
    playMainV() {
      this.$refs.mainV.play();
      this.$refs.mainV.muted = false;
      this.$refs.smallV.muted = true;
      this.$refs.smallV.play();
      this.$refs.smallV.currentTime = this.$refs.mainV.currentTime;
      this.playPic = false;
      this.isClose = false;
      this.isShowMainVideo = true;
    },
    //关闭小窗动画
    stopSmallVideo() {
      //关闭视频小窗
      this.offMin = false;
      //确认关闭小窗操作
      this.isClose = true;
      //结束主播放器播放并归零,解除静音
      this.$refs.mainV.pause();
      this.$refs.smallV.pause();
      this.$refs.mainV.muted = false;
      // this.mainV.currentTime = 0;
      this.$refs.mainV.currentTime = this.$refs.smallV.currentTime;
      this.playPic = true;
    },
    //回到主视频位置动画
    enlargeToMainVideo() {
      this.$refs.mainV.scrollIntoView({ behavior: "smooth" });
    },
    //禁止ios全屏按钮播放
    disableFullscreen() {
      return false;
    },
    onScroll(currentScroll) {
      if (currentScroll)
        if (currentScroll < this.$refs.intro.offsetTop - this.$refs.nav.clientHeight - 40) {
          this.navIndex = 0;
        } else if (currentScroll >= this.$refs.intro.offsetTop - this.$refs.nav.clientHeight - 40 && currentScroll < this.$refs.claim.offsetTop - this.$refs.nav.clientHeight - 40) {
          this.navIndex = 1;
        } else {
          this.navIndex = 2;
        }
      let top = Math.floor(document.body.scrollTop || document.documentElement.scrollTop || window.pageXOffset);
      this.topshow = top >= this.$refs.intro.offsetTop - 100;
    },
    //视频操作结束
    setshare() {
      let that = this;
      let shareurl;
      if (that.$route.query.openId) {
        setSessionObj("openId", that.$route.query.openId);
      }
      shareurl = "https://insapp.hsbxjj.com/weixinBridge/weixinBridge.html?redirect_uri=" + encodeURIComponent(window.location.href);

      let outuurl =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx19e9bec291539dce&redirect_uri=" +
        encodeURIComponent(shareurl) +
        "&response_type=code&scope=snsapi_userinfo&connect_redirect=1#wechat_redirect";
      if (navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1) {
        //微信分享
        that.$http
          .get(wxConfigUrl, { params: { url: encodeURIComponent(location.href.split("#")[0]) } })
          .then((res) => {
            let data = res.data;
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: data.appId, // 必填，公众号的唯一标识
              timestamp: data.timestamp, // 必填，生成签名的时间戳
              nonceStr: data.nonceStr, // 必填，生成签名的随机串
              signature: data.signature, // 必填，签名
              jsApiList: ["checkJsApi", "updateAppMessageShareData", "updateTimelineShareData", "onMenuShareTimeline", "onMenuShareAppMessage"], // 必填，需要使用的JS接口列表
            });
            wx.ready(() => {
              wx.updateAppMessageShareData({
                title: that.productShareTitle,
                desc: that.productSharePlans,
                link: shareurl, //outuurl,
                imgUrl: that.productShareImgUrl,
                success: function () {},
              });
              wx.updateTimelineShareData({
                title: that.productSharePlans,
                link: shareurl, //outuurl,
                imgUrl: that.productShareImgUrl,
                success: function () {},
              });
            });
          })
          .catch(() => {
            showMsg("服务器异常");
          });
        // }
      } else if (window.daka || navigator.userAgent.indexOf("daka") > -1 || getUrlParams().daka === "1") {
        if (isAndroid()) {
          window.share = {
            //站外
            title: that.productShareTitle,
            desc: that.productSharePlans,
            url: outuurl, //shareurl,
            icon: that.productShareImgUrl,
            //站内
            inStationTitle: that.productShareTitle,
            inStationDesc: that.productSharePlans,
            inStationIcon: that.productShareImgUrl,
            inStationUrl: shareurl,
            // wechatTimelineUseTitle: "1", 控制朋友圈显示标题还是详情
            activeType: "bxcx2020jzz", //不确定有啥用 保留
            tag: "保险模版",
            category: JSON.stringify(["0", "1", "3"]),
          };
        } else {
          window.share = {
            //站外
            title: that.productShareTitle,
            desc: that.productSharePlans,
            url: outuurl, //shareurl,
            icon: that.productShareImgUrl,
            //站内
            inStationTitle: that.productShareTitle,
            inStationDesc: that.productSharePlans,
            inStationIcon: that.productShareImgUrl,
            inStationUrl: shareurl,
            // wechatTimelineUseTitle: "1", 控制朋友圈显示标题还是详情
            activeType: "bxcx2020jzz", //不确定有啥用 保留
            tag: "保险模版",
            category: JSON.stringify(["0", "1", "2", "3"]),
          };
        }
      }
    },
    // 获取基础数据信息
    getBasicsData() {
      let data = {};
      data.userId = this.userId;
      data.channelId = getUrlParams().channelId || "";
      data.productCode = getUrlParams().productCode || "";
      this.$http.post(productDetail, data).then((res) => {
        let d = res.data.data;
        this.isLive = d.isLiving;
        this.isShowVideo = d.isShowVideo;
        this.productBannerUrl = d.basicInfo.productBannerUrl;
        this.productName = d.basicInfo.productName;
        this.productShareImgUrl = d.basicInfo.productShareImgUrl;
        this.productSharePlans = d.basicInfo.productSharePlans;
        this.productShareTitle = d.basicInfo.productShareTitle;
        this.bannerImg = d.basicInfo.productBannerUrl;
        if (d.isShowVideo === 1) {
          this.posterImg = d.videoInfo.videoPicUrl;
          this.videoUrl = d.videoInfo.videoUrl;
          this.$refs.mainV.src = d.videoInfo.videoUrl;
          this.$refs.smallV.src = d.videoInfo.videoUrl;
        }
        try {
          //设置分享
          if (this.productShareTitle && this.productSharePlans && this.productShareImgUrl) {
            this.setshare();
          }
        } catch (e) {}
      });
    },
    // 获取争霸赛排名接口
    getRankingData() {
      this.$http.post(getRankingDataUrl).then((res) => {
        if (res.data.flag) {
          this.rankingList = res.data.data.weekRanking;
        } else {
          showMsg(res.data.message);
        }
      });
    },
    // 跳转争霸赛
    jumpRanking() {
      this.$router.push({ path: "/activePage" });
    },
    callphone() {
      this.customerServiceVisibile = true;
      try {
        myTrack("bxsc_customer_service", {
          customer_service_page: "优驾保UBI网络货运物责险",
          product_channel: getUrlParams().orderSource ? getUrlParams().orderSource : "",
        });
      } catch (e) {}
    },
    zhugeGobackTage(cb) {
      cb && cb();
      window.h5_native.execNative("closeWindow", { code: "", args: {} });
    },

    // 返回拦截处理
    goback(event) {
      console.log("goback triggered, route name:", this.$route.name, "hasChildRoute:", this.hasChildRoute);

      // 如果当前有子路由标志，说明是从子路由返回，不拦截
      if (this.hasChildRoute) {
        console.log("从子路由返回，不拦截");
        this.hasChildRoute = false; // 清除标志
        return;
      }

      // 检查页面是否已经初始化完成，防止初始化时误触发
      if (this.$route.name == "home") {
        // 阻止默认返回行为
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        // 立即重新推入历史记录状态
        history.pushState(null, null, document.URL);
        // 调用挽留判断
        this.checkRetentionFromAPI();
      }
    },

    removeEventPopstate() {
      window.removeEventListener("popstate", this.goback, false);
    },

    // 调用接口判断是否需要挽留
    async checkRetentionFromAPI() {
      try {
        const params = {
          userId: getUserInfo().userId || "",
          businessProductCode: getUrlParams().productCode || "",
        };

        this.$http
          .post("/hsbxjj-standard-common-insurance/standardinsurance/user/operate/ins/back", params)
          .then((res) => {
            // 需要挽留，显示弹框
            if (res.data.isPupWindow) {
              this.showRetentionDialog = true;
              this.trackRetentionShow();
            } else {
              // 不需要挽留
              this.doExit();
            }
          })
          .catch(() => {});
      } catch (error) {
        // 接口异常，默认不挽留
        this.doExit();
        console.error("检查挽留接口调用失败:", error);
      }
    },

    // 挽留弹框确认（继续浏览）
    onRetentionConfirm() {
      this.showRetentionDialog = false;
      // 跳转到企业微信聊天界面
      window.location.href = "https://work.weixin.qq.com/kfid/kfc4cf3b5ef01b159af";
      this.trackRetentionStay();
    },

    // 挽留弹框取消（确定离开）
    onRetentionCancel() {
      this.showRetentionDialog = false;
      this.trackRetentionLeave();
      this.doExit();
    },

    // 执行退出操作
    doExit() {
      console.log("doExit called");
      if (window.daka || navigator.userAgent.indexOf("daka") > -1) {
        window.h5_native.execNative("closeWindow", { code: "", args: {} });
      } else {
        // 移除popstate监听，避免再次触发goback
        this.removeEventPopstate();
        // 直接使用window.close()或history.back()
        if (window.opener) {
          window.close();
        } else {
          // 尝试返回上一页
          window.history.back();
          // 如果无法返回，尝试关闭标签页（某些浏览器支持）
          setTimeout(() => {
            window.close();
          }, 100);
        }
      }
    },

    // 挽留弹框展示埋点
    trackRetentionShow() {
      try {
        myTrack("service_popup", {
          service_popup_show: "客服弹框-展示",
        });
      } catch (error) {}
    },

    // 用户选择继续浏览埋点
    trackRetentionStay() {
      try {
        myTrack("service_popup", {
          service_popup_content: "客服弹框-联系",
        });
      } catch (error) {}
    },

    // 用户选择离开埋点
    trackRetentionLeave() {
      try {
        myTrack("service_popup", {
          service_popup_doexit: "客服弹框-退出",
        });
      } catch (error) {}
    },

    // 切换阅读须知状态
    toggleReadNotice() {
      this.readNotice = !this.readNotice;
      // 在这里添加埋点
      try {
        myTrack("bxsc_go_to_the_product_page", {
          check_read_confirm: this.readNotice ? "确认勾选" : "取消勾选",
        });
      } catch (error) {
        window.console.log("埋点失败:", error);
      }
    },
  },
  beforeMount() {
    if (document.body.scrollTop > 0) {
      location.reload();
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.showLegal = true;
      // if (!from.name) {
      //     if (window.daka && getUrlParams().hp == 1) {
      //         vm.showLegal = false;
      //     } else {
      //         vm.showLegal = true;
      //     }
      // }
    });
  },
  watch: {
    $route(to, from) {
      console.log("$route watcher - from:", from && from.path, "to:", to.path);

      // 从 home 进入子路由时，设置标志位
      if (from.name === 'home' && to.path.startsWith('/home/')) {
        console.log("进入子路由，设置标志位");
        this.hasChildRoute = true;
      }

      // 当返回到home页面时，重新初始化历史记录状态
      if (to.name === "home" && from.name !== "home") {
        this.$nextTick(() => {
          if (window.history && window.history.pushState) {
            history.pushState(null, null, document.URL);
          }
        });
      }
    },
  },
  mounted() {
    let that = this;
    // 确保历史记录初始化
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      // 延迟添加事件监听器，避免初始化时误触发
      window.addEventListener("popstate", this.goback, false);
    }
    window.addEventListener(
      "message",
      function (type) {
        if (type.data.hasOwnProperty("action") && type.data.action == "closeCustomerService") {
          // 接收联系客服关闭按钮事件
          that.customerServiceVisibile = false;
        }
      },
      false
    );
    try {
      myTrack("bxsc_go_to_the_product_page", {
        product_id: getUrlParams().productCode ? getUrlParams().productCode : "",
        product_name: "优驾保UBI网络货运物责险",
        product_company: "平安保险",
        product_source: getUrlParams().orderSource ? getUrlParams().orderSource : "",
      });
    } catch (e) {}
    let request = window.indexedDB.open("my-database", 2);
    window.console.log(request);
    this.getBasicsData();
    this.getRankingData();
    //---------------------------------关于视频播放时间监听开始------------------------------------
    //获取轮播图出页面的相对高度高度
    this.mainV = this.$refs.mainV;
    this.smallV = this.$refs.smallV;
    this.smallV.muted = true;
    let BannerHeight;
    if (this.$refs.banners) {
      BannerHeight = this.$refs.banners.offsetHeight + this.$refs.mainVideo.offsetHeight - 50;
    } else {
      BannerHeight = this.$refs.mainVideo.offsetHeight - 50;
    }
    // play：播放监听
    this.mainV.addEventListener("play", function () {
      window.console.log("主体视频正在播放中");
      that.isPlay = true;
      that.isClose = false; //只要主体播放器播放，就从新激活小窗功能
    });
    //pause:播放暂停
    this.mainV.addEventListener("pause", function () {
      window.console.log("主体视频暂停播放");
      that.isPlay = false;
    });
    // ended：播放结束
    this.mainV.addEventListener("ended", function () {
      window.console.log("主体视频播放完了");
      that.mainV.muted = false;
      that.isPlay = false;
      that.playPic = true;
    });
    // ended：播放结束
    this.smallV.addEventListener("ended", function () {
      window.console.log("小窗视频播放完了");
      that.offMin = false;
      that.playPic = true;
    });
    setTimeout(function () {
      //初始化直播拖拽事件
      new Inertia(that.$refs.liveAnimation, {}, true);
    }, 500);
    //---------------------------------关于视频播放事件监听结束----------------------------------
    let top = this.$refs.plan.$el.offsetTop;
    let scrollDom = this.$refs.content;
    let space = this.$refs.intro.offsetHeight + parseInt(getComputedStyle(this.$refs.intro).marginBottom);
    scrollDom.addEventListener("scroll", () => {
      let myScrollTop = scrollDom.scrollTop;
      if (myScrollTop > this.$refs.process.$el.offsetTop - space && myScrollTop < this.$refs.claims.$el.offsetTop - space) {
        this.introIndex = 0;
      } else if (myScrollTop > this.$refs.claims.$el.offsetTop - space && myScrollTop < this.$refs.clause.$el.offsetTop - space) {
        this.introIndex = 1;
      } else if (myScrollTop >= this.$refs.clause.$el.offsetTop - space && myScrollTop < this.$refs.problem.$el.offsetTop - space) {
        this.introIndex = 2;
      } else if (myScrollTop >= this.$refs.problem.$el.offsetTop - space) {
        this.introIndex = 3;
      }
      this.showBackToTop = myScrollTop > top;

      // let content = document.getElementById("content")
      let top = Math.floor(document.body.scrollTop || document.documentElement.scrollTop || window.pageXOffset);
      that.onScroll(top);
      // window.console.log(that.$refs.mainVideo.getBoundingClientRect().top);
      // console.log("=========");
      // window.console.log(that.$refs.mainVideo.offsetHeight);
      //小窗口播放器显示隐藏控制
      if (that.$refs.detail.getBoundingClientRect().top < 0 && !this.isSpinner) {
        this.isSpinner = true;
      }
      if (that.$refs.mainVideo.getBoundingClientRect().top < -(that.$refs.mainVideo.offsetHeight + 50) && !that.$refs.mainV.paused) {
        //防止多次触发
        if (that.offMin) return;
        that.offMin = true; //小窗显示开关
        that.$nextTick(function () {
          that.$refs.smallV.play();
          that.$refs.mainV.muted = true; //静音
          that.$refs.smallV.currentTime = that.$refs.mainV.currentTime;
          that.$refs.smallV.muted = false;
          //初始化小窗拖拽事件
          new Inertia(this.$refs.smallVideo);
        });
      } else {
        //防止多次触发
        if (!that.offMin) return;
        that.offMin = false;
        if (!that.isClose) {
          //没有从小窗直接关闭
          that.$refs.mainV.currentTime = that.$refs.smallV.currentTime;
          that.$refs.mainV.play();
          that.$refs.mainV.muted = false; //不静音
          that.$refs.smallV.muted = true;
        } else {
          //从小窗直接关闭
          that.$refs.mainV.currentTime = 0;
          that.$refs.mainV.pause();
          that.offMin = false; //小窗显示开关
        }
      }
      //小窗口播放器显示隐藏控制结束
    });
    // 电销10s推送
    setInterval(function () {
      let url = "/hsbxjj-standard-common-insurance/telemarketing/noIssued";
      let data = {
        mobile: getUserInfo().mobile,
        businessProductShowName: "优驾保UBI网络货运物责险",
        businessProductCode: getUrlParams().productCode,
        telemarketChannelCode: getUrlParams().orderSource,
        telemarketType: 2,
      };
      // data = qs.stringify(data);
      that.$http
        .post(url, data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {})
        .catch((error) => {});
    }, 10000);
  },
  beforeDestroy() {
    // 清理popstate监听器
    this.removeEventPopstate();
  },
};
</script>

<style scoped lang="scss">
.content {
  position: absolute;
  width: 100vw;
  bottom: 14.67vw;
  top: 0;
  overflow: scroll;

  .banner {
    width: 100vw;
    height: 53.333vw;
    background-repeat: no-repeat;
    background-size: 100%;
  }

  .detail {
    width: 100vw;
    background-color: rgba(255, 145, 144, 0.2);
    position: relative;
    font-size: 3.47vw;
    overflow: hidden;
    margin: 2.67vw auto 0;

    .lpwyDomBox {
      padding-left: 8vw;
      position: relative;
      height: 9.3vw;
      line-height: 10vw;
      color: #e94c4a;

      &::before {
        content: "";
        position: absolute;
        top: 3vw;
        left: 2.67vw;
        right: 0;
        bottom: 0;
        width: 4vw;
        height: 4vw;
        background: url("../assets/horn.png") no-repeat;
        -webkit-background-size: contain;
        background-size: contain;
        z-index: 1;
      }

      .ml10 {
        margin-left: 10px;
      }

      .mr20 {
        margin-right: 2.66vw;
      }

      .mr30 {
        margin-right: 4vw;
      }

      .small {
        font-size: 2.6vw;
      }
    }
  }

  /*直播标识*/
  .liveAnimation {
    position: fixed;
    width: 20vw;
    height: 26vw;
    right: 0;
    top: 80vw;
    z-index: 999;

    img {
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 1.33vw;
    }
  }

  /* 播放器样式开始 */

  .mainVideo {
    width: 100vw;
    height: 51.47vw;
    background-color: #fff;

    .videoBox {
      width: 100%;
      height: 51.47vw;
      margin: 0 auto;
      position: relative;

      > img {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .playBtn {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 2;

        img {
          display: block;
          width: 13.87vw;
          margin: 18.8vw auto 0;
        }
      }

      .disableFullscreen {
        width: 20%;
        height: 30%;
        background-color: red;
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
      }
    }
  }

  .smallVideo {
    position: fixed;
    width: 42.67vw;
    height: 24vw;
    text-align: center;
    color: #fff;
    text-decoration: none;
    right: 0;
    bottom: 16vw;
    z-index: 999;

    .smallVideoBox {
      position: relative;
      width: 42.67vw;
      height: 24vw;

      .close {
        position: absolute;
        top: 1.33vw;
        right: 1.33vw;
        z-index: 1;
        width: 5.87vw;
        height: 5.87vw;
      }

      .enlarge {
        position: absolute;
        bottom: 1.33vw;
        right: 1.33vw;
        z-index: 1;
        width: 5.87vw;
        height: 5.87vw;
      }
    }
  }

  video::-webkit-media-controls-fullscreen-button {
    display: none;
  }

  video::-internal-media-controls-download-button {
    display: none;
  }

  video::-webkit-media-controls-enclosure {
    overflow: hidden;
  }

  video::-webkit-media-controls-panel {
    width: calc(100% + 30px);
  }

  .videoplay {
    object-fit: cover;
  }

  /* 播放器样式结束 */

  .ensure {
    width: 100%;
    background: #ffffff;

    tr {
      height: 13.33vw;
      line-height: 13.33vw;

      td {
        border-bottom: 0.27vw solid #f5f5f9;
      }

      td:nth-child(1) {
        padding-left: 5.33vw;
        text-align: left;
        color: #333333;
      }

      td:nth-child(2) {
        padding-right: 5.33vw;
        text-align: right;
        color: #999999;
      }
    }

    .duty {
      margin-bottom: 2.67vw;
      line-height: 5.33vw;
      font-size: 3.2vw;
      color: #999999;

      p {
        text-indent: -9.8vw;
        margin-left: 9.8vw;
      }
    }
  }

  .tips {
    height: 13vw;
    padding: 0 5.33vw;
    margin: 5.33vw auto 20vw;
    font-size: 3.2vw;
    text-align: left;
    color: #999999;

    p {
      line-height: 5vw;

      span {
        color: #3385ff;
        text-decoration: underline;
      }
    }
  }

  .intro {
    position: sticky;
    display: flex;
    top: 0;
    height: 16vw;
    margin: 2.67vw 0;
    justify-content: space-around;
    background: #ffffff;

    div {
      line-height: 16vw;
      color: #333333;
      font-weight: bold;
    }

    .selected {
      color: #3385ff;
      border-bottom: 0.27vw solid #3385ff;
    }
  }

  .notice {
    display: flex;
    padding: 2vw 5.33vw;
    font-size: 3.6vw;
    text-align: left;
    color: #999;
    position: fixed;
    bottom: 14.67vw;
    left: 0;
    width: 100vw;
    height: max-content;
    line-height: 5vw;
    min-height: 6vw;
    background-color: #fff;
    border: 1px solid #c7c7c7;
    border-left: none;
    border-right: none;

    .check-btn {
      width: 5.33vw;
      height: 5vw;
      background: url("../assets/uncheck.png") no-repeat center;
      background-size: 4vw;
    }

    .selected {
      background: url("../assets/checked.png") no-repeat center;
      background-size: 4vw;
    }

    p {
      width: 87vw;
      line-height: 5vw;

      span {
        color: #3385ff;
      }
    }
  }
}

.submit {
  position: absolute;
  display: flex;
  bottom: 0;
  height: 14.67vw;

  .customer {
    width: 16vw;
    padding-top: 8.67vw;
    border-right: 0.27vw solid #dddddd;
    font-size: 2.93vw;
    color: #333333;
    background: url("../assets/customer.png") no-repeat center 2.67vw #ffffff;
    background-size: 5.33vw;
    vertical-align: middle;
    text-decoration: none;
  }

  .price {
    width: 42vw;
    height: 14.67vw;
    line-height: 14.67vw;
    text-align: center;
    font-size: 4.8vw;
    color: #ff9000;
    background: #ffffff;
    vertical-align: middle;
  }

  .submit-btn {
    display: inline-block;
    width: 42vw;
    height: 14.67vw;
    line-height: 14.67vw;
    text-align: center;
    font-size: 4.56vw;
    color: #ffffff;
    background: #3385ff;
    vertical-align: middle;
  }
}

.top-img {
  position: absolute;
  bottom: 20vw;
  right: 5.33vw;
  width: 13.33vw;
}

#iframe {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
}
</style>
